// extracted by mini-css-extract-plugin
export default {"startMenuAppsContList":"start-menu-cont-apps-list-all_startMenuAppsContList__esDa9"};